import { resultsDuckCreator } from 'axl-ducks';

import { srpDuckPreset } from '@/ducks/presets/index.js';

export default resultsDuckCreator({
    ...srpDuckPreset,
    store: 'activeEmailListing',
});
